import { useLocation, useNavigate } from 'react-router-dom';
import useScriptRef from 'hooks/useScriptRef';
import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';

export default function ViewCertificate() {
    const navigate = useNavigate();
    const { isLoggedIn } = useAuth();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const scriptedRef = useScriptRef();

    useEffect(() => {
        if (isLoggedIn) navigate(`/certificates/${id}/details`, { replace: true });
        else navigate(`/certificates/${id}/summary`, { replace: true });
    }, [isLoggedIn, id, navigate]);

    return <></>;
}
